import { List, Modal, Typography } from "@mui/material";
import React from "react";
import {
  ArbeitsplanType,
  UserType,
  WorkPlanListProps,
} from "../../utils/types";
import { ArbeitsplanDetailsItem } from "./ArbeitsplanDetailsItem";

export const ArbeitsplanDetailsModal = ({
  workPlanList: workPlanList,
  userList: users,
  setIsModalOpen,
  isModalOpen,
}: {
  workPlanList: ArbeitsplanType[];
  userList: UserType[];
  isModalOpen: boolean;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  return (
    <Modal
      open={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div
        className="thread-list-item"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "70vh",
          width: "90%",
          marginLeft: "5%",
          marginTop: "20vh",
          marginBottom: "20vh",
          maxHeight: "600px",
          borderRadius: "10px",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
          backgroundColor: "#fff",
        }}
      >
        <List
          sx={{
            width: "100%",
            height: "100%",
            bgcolor: "background.paper",
            overflow: "auto",
          }}
        >
          <div
            className="d-flex justify-content-between mb-3"
            style={{ marginLeft: "15px", marginTop: "10px" }}
          >
            <Typography variant="h4">Details</Typography>
          </div>
          {workPlanList.map((workPlan, index) => (
            <ArbeitsplanDetailsItem
              key={index}
              workPlan={workPlan}
              users={users}
            />
          ))}
        </List>
      </div>
    </Modal>
  );
};
